
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "KPOTDDCFVD",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/KPOTDDCFVD.vue